const React = require('react');
const ReactIntl = require('react-intl');
const injectIntl = ReactIntl.injectIntl;
const { isNil } = require('lodash');

const defaultMessages = require('../../i18n/messages/default');
const IntlProvider = ReactIntl.IntlProvider;
const Footer = require('../Footer/Footer');
const Header = require('../Header/Header');
const LoginActions = require('../../actions/LoginActions');
const LoginStore = require('../../stores/LoginStore');
const AppConstants = require('../../constants/AppConstants')
const UrlUtils = require('../../utils/urlUtils');
const Utils = require('../../utils/Utils.js');
const createReactClass = require('create-react-class');
const PageCase = require('../PageCase/PageCase.js');
const LoginBoxWrapper = require('../LoginBoxWrapper/LoginBoxWrapper.js');
const { Input, Button } = require('metro-ui-components');
const { Modal, ModalContent, Separator } = require("@metro-ui/core");

const LoginHiddenFields = require('../Login/LoginHiddenFields.js');
const PasswordField = require('../Password/PasswordField.js');
const LoginHelper = require('../../utils/loginHelper.js');
const LoginHandler = require('../Login/LoginHandler.js');
const TwoFactorAuthenticationRenderer = require('../TwoFactorAuthenticationRenderer/TwoFactorAuthenticationRenderer.js');
const AuthMethodsHandler = require('../Login/AuthMethodsHandler.js');
const ReCaptcha = require('../../utils/ReCaptcha');

const SuppLogin = createReactClass({
    displayName: 'SuppLogin',
    getInitialState() {
        return {
            localeId: this.props.localeId,
            userMFAMethods: [],
            hideYouAndMetroDigitalComponent: true,
            isSocialModalOpen: false,
            focusPasswordInput: false,
        };
    },

    componentWillMount: function () {
        //check whether to display login box TOTP box
        this.showDirectTOTP(window.location.href);
    },
    componentDidMount: function () {
        LoginStore.addChangeListener(this.changeHandler);
        LoginStore.addChangeListener(this._onFooterConfigChange);
        this.renderConfirmation(this.props.emailSentForgotPassword);
        ReCaptcha.attachRecaptchaScript(this.props.clientId, this.props.realmId);
        this.prefillLoginInput();
    },
    finalRedirectUri: '',
    showDirectTOTP(directOTPuri) {
        // In case of 2FA if the User already logged in
        // try a new page to access show OTP again
        const appState = LoginStore.getState();
        let urlIdToken = UrlUtils.getParameterByName('id_token', directOTPuri);
        let urlLoginId = UrlUtils.getParameterByName('login_id', directOTPuri);
        let urlCode = UrlUtils.getParameterByName('code', directOTPuri);
        let urlRedirectUri = UrlUtils.getParameterByName('redirect_uri', directOTPuri);
        this.finalRedirectUri = urlRedirectUri ? urlRedirectUri.concat("#code=").concat(urlCode).concat("&id_token=").concat(urlIdToken) : '';
        let urlParsed_token = Utils.tryParseToken(urlIdToken);

        const authMethod = LoginHelper.getAuthMethod(urlParsed_token);
        if (urlParsed_token && authMethod) {
            LoginActions.getUserMFAMethods(urlIdToken, this.props.countryCode);
            this.setState({
                showTOTPControl: authMethod,
                loginId: urlLoginId,
                phone: urlParsed_token.phone,
                emailId: urlParsed_token.email,
                idToken: urlIdToken,
                userId: urlParsed_token.sub,
                userMFAMethods: appState.userMFAMethods,
                authMethodDeviceName: !isNil(appState.userMFAMethods) && appState.userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(appState.userMFAMethods).name : '',
                credentialId: !isNil(appState.userMFAMethods) && appState.userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(appState.userMFAMethods).credentialId : ''
            });
        }
    },

    googleAnalyticsSendForgotPassEvents(){
        Utils.googleAnalyticsClickEvents('click_on_forgot_password','interaction', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false );
    },

    _onFooterConfigChange: function () {
        let appState = LoginStore.getState();
        this.setState({ forgotPwdLinkUrl: appState.forgotPwdLinkUrl });
    },

    prefillLoginInput() {
        const { loginId } = this.props;
        loginId ? this.setState({ loginId, focusPasswordInput: true }) : null
    },

    onLogin() {
        const { loginId, password } = this.state;

        if (!(loginId && password)) {
            return;
        }

        if (UrlUtils.isSamlFlow()) {
            LoginActions.submitSamlLogin(loginId, password, this.props.userType, this.props.clientId, this.props.countryCode, this.state.localeId, this.props.realmId, this.props.traceId);
        } else {
            ReCaptcha.getRecaptchaToken((token) =>
                LoginActions.submitLogin(loginId, password, this.props.userType,
                    this.props.clientId, this.props.responseType, this.props.countryCode, this.state.localeId, this.props.realmId, this.props.accountId,
                    this.props.redirectUrl, this.props.state, this.props.prompt, this.props.nonce, this.props.scope, this.props.traceId, this.props.codeChallenge,
                    this.props.codeChallengeMethod, token)
            );
        }
    },

    onLoginIdChange(value) {
        this.setState({ loginId: value });
    },

    onPasswordChange(password) {
        this.setState({ password: password });
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    renderTwoFactorAuthenticationComponent() {
        return (
            <TwoFactorAuthenticationRenderer
                {... this.props}
                phone={this.state.phone}
                emailId={this.state.emailId}
                login={this.state.loginId}
                idToken={this.state.idToken}
                userId={this.state.userId}
                credentialId={this.state.credentialId}
                authMethodDeviceName={this.state.authMethodDeviceName}
                directOtpRedirectUri={this.finalRedirectUri}
                twoFaAuthMethod={this.state.showTOTPControl}
                userMFAMethods={this.state.userMFAMethods}
                showTryOtherLink={this.state.userMFAMethods ? this.state.userMFAMethods.length > 1 : false}
            />
        );
    },

    setLoginState(value) {
        this.setState(value)
    },

    renderConfirmation(code) {

        if (code == AppConstants.EmailSentCode.FORGOTPASSWORD) {
            // 200 represents the forgot password mail is successfully sent 
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['emailSentForgotPasswordConfirmationMasg']), "success");
        } else if (code == AppConstants.EmailSentCode.RESETPASSWORD) {
            // 300 represents the reset password is successfully done
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['emailSentResetPasswordConfirmationMasg']), "success");
        } else if (code == AppConstants.EmailSentCode.RESETPASSWORDERROR) {
            // 400 represents the some problem is reset password flow
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['resetPasswordError']), "error");
        } else if (code == AppConstants.EmailSentCode.VALIDATETOTPERROR) {
            // 400 represents the some problem is reset password flow
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]), "error");
        }
    },

    showSocialLogin() {
        return false;
    },

    renderLogin() {
        const label = this.props.intl.formatMessage(defaultMessages['userName']);
        const loginButtonText = this.props.intl.formatMessage(defaultMessages['loginBtnTxt']);
        return (
            <React.Fragment>
                <LoginBoxWrapper>
                    <div>
                        <form id="authForm" noValidate="novalidate" onSubmit={event => event.preventDefault()} autoComplete="off" >
                            <Input
                                id="user_id"
                                type="email"
                                key="user_id"
                                name="user_id"
                                autoComplete="off"
                                label={label}
                                required={true}
                                defaultValue={this.props.loginId || ""}
                                hasWarning={this.state.loginError ? true : false}
                                onChange={(_, value) => { this.onLoginIdChange(value) }}
                                onKeyUp={(_, value) => { this.onLoginIdChange(value) }}
                                onKeyDown={(_, value) => { this.onLoginIdChange(value) }}
                                autoFocus={true}
                            />
                            <PasswordField
                                {... this.props}
                                onPasswordChange={this.onPasswordChange} 
                                focusInput={this.state.focusPasswordInput}
                                />
                            <LoginHiddenFields {... this.props} />
                            <Button
                                id="submit"
                                type="submit"
                                value="submit"
                                kind="primaryRaised"
                                size="large"
                                className="primary-button"
                                almostActive={!(this.state.loginId && this.state.password)}
                                onClick={Utils.debounce(this.onLogin)}
                            >
                                {loginButtonText}
                            </Button>
                        </form>
                        <div className="row">
                            <div className="forgotPasswordLink" onClick={() => this.googleAnalyticsSendForgotPassEvents()}>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div>
                                        {this.state.forgotPwdLinkUrl &&
                                            <a href={this.state.forgotPwdLinkUrl} className="boldTextLabel">
                                                {this.props.intl.formatMessage(defaultMessages['forgotPassword'])}
                                            </a>
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                </div>
                            </div>
                        </div>
                    </div>
                </LoginBoxWrapper>
                {this.showSocialLogin() && this.renderSocialLogin()}
                {/* {this.renderSocialLoginModal()} */}
            </React.Fragment>
        );
    },

    handleModalOpen(modalStatus, eventAction = '', eventLabel = '') {
        if (eventAction) {
            Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);
        }

        this.setState({ isSocialModalOpen: modalStatus });
    },

    handleSocialLoginElementHover(eventAction = '', eventLabel = '') {
        Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);
    },

    handleDishButtonClick(eventAction, eventLabel) {
        const { props } = this;

        Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);

        const url =
            window.location.protocol +
            "//" +
            window.location.host +
            AppConstants.Links.SOCIAL_LOGIN_REDIRECT_URL +
            "?" +
            AppConstants.UrlParams.CLIENT_ID +
            "=" +
            AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.clientId +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.REALM_ID,
                AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.realmId
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.LOCALE_ID,
                this.state.localeId
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.REDIRECT_URI,
                AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.redirectUrl[window.WebConstants.stage]
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.USER_TYPE,
                AppConstants.UserTypes.CUST
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.RESPONSE_TYPE,
                props.responseType
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.COUNTRY_CODE,
                props.countryCode
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.PROVIDER,
                AppConstants.Providers.KEYCLOAK
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.SCOPE,
                AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.scope
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.STATE,
                AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.state
            ) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.SLP_FINAL_REDIRECT_URI,
                encodeURIComponent(props.redirectUrl)
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.SLP_FINAL_CLIENT_ID,
                props.clientId
            ) +
            UrlUtils.appendQueryParam(
                AppConstants.UrlParams.SLP_FINAL_REALM_ID,
                props.realmId
            );

        window.location = url;
    },

    renderSocialLogin() {
        const { CLICK, HOVER } = AppConstants.SOCIAL_LOGIN.EVENTS;
        const { DISH } = AppConstants.SOCIAL_LOGIN.PROVIDER;

        return (
            <div className="socialLoginContainer" >
                <div className="textContainer">
                    <div className="separatorWidth">
                        <Separator />
                    </div>
                    <div className="separatorText">
                        {this.props.intl.formatMessage(defaultMessages["loginpage.login_with"])}
                    </div>
                    <div className="separatorWidth">
                        <Separator />
                    </div>
                </div>
                <div className="imagesContainer">
                    <div className="dish" onClick={() => { this.handleDishButtonClick(CLICK, DISH) }} onMouseEnter={() => { this.handleSocialLoginElementHover(HOVER, DISH) }}>
                        <img
                            className="socialLogo dishLogo"
                            alt="Dish Authentication"
                            src="assets/images/Logo_Dish_Color_RGB.png"
                        />
                        <div>
                            {this.props.intl.formatMessage(defaultMessages["loginpage.login_with_dish"])}
                        </div>
                    </div>
                </div>
            </div >
        );
    },

    renderSocialLoginModal() {
        const { isSocialModalOpen } = this.state;
        return (
            <Modal aria-labelledby="modal-title" isOpen={isSocialModalOpen}>
                <ModalContent direction="column" padding="large" spacing="medium">
                    <div className="socialModalContainer">
                        <div className="modalTitle">
                            {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_title"])}
                        </div>
                        <div className="modalContent">
                            {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_text"])}
                        </div>
                        <div className="loginWithEmailButton">
                            <button
                                className="closeModalButton"
                                onClick={() => this.handleModalOpen(false)}
                            >
                                {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_button"])}
                            </button>
                        </div>
                    </div>
                </ModalContent>
            </Modal>
        );
    },

    changeHandler() {
        let appState = LoginStore.getState();
        //Check for availability of queryparam postlogonurl if present update with redirect_uri
        let customerComponentLinks = UrlUtils.formatCustCompLinks(
            appState.customerComponentLinks || {},
            this.props.redirectRawUrl
        );

        this.setState({
            customerComponentLinks: customerComponentLinks,
            hideYouAndMetroDigitalComponent: appState.hideYouAndMetroDigitalComponent
                ? appState.hideYouAndMetroDigitalComponent
                : false,
        });
    },


    renderContent: function () {

        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        // @todo bodyheader
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = this.state.showTOTPControl
            ? this.renderTwoFactorAuthenticationComponent()
            : this.renderLogin();
        return (
            <div>
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer newDesign larger-device-width smaller-device">
                            <div
                                className={`col-xs-12 smaller-device-inside-wrap loginCard open`}
                            >
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{headerMessage}</span>
                                        </div>
                                    </div>
                                </div>
                                {renderedComponent}

                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
                <LoginHandler
                    {...props}
                    loginId={this.state.loginId}
                    localeId={this.state.localeId}
                    setState={(value) => {
                        this.setLoginState(value)
                    }}
                />
                <AuthMethodsHandler
                    {...props}
                    setState={(value) => {
                        this.setLoginState(value)
                    }}
                />
            </div>
        );
    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        )
    },
    render: function () {
        return (
            <PageCase
                header={< Header removeNavbar countryCode={this.props.countryCode} />}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        );
    }
});

module.exports = injectIntl(SuppLogin);
